<template>
    <div class="d-flex" :class="{'disabled':disabled}">
        <!--todo 插槽-->
        <slot name="front"/>

        <!--todo 國碼下拉-->
        <CountryCodeSelect ref="selectCountryCode" v-if="isCountryCode" v-model="selectCountryCodeData" :countryCodeData="selectCountryCodeData" @visible-change="handleVisibleChange" :disabled="disabled"/>

        <!--todo 國碼台灣-->
        <div class="CountryCodeTW" v-if="isTW">TW+886</div>

        <!--todo 不是輸入匡-->
        <span class="input" :class="{'show-password': !Eyes}" ref="eyes" v-if="placeholder===''">{{Model}}</span>

        <!--todo 輸入匡-->
        <input v-else v-model="Model"
                @change="onChange"
                @focus="onFocus"
                @blur="onBlur"
                ref="eyes"
                class="input enter"
                :class="{'show-password': !Eyes && this.type==='chinese'}"
                :disabled="disabled"
                :placeholder="placeholder"
                autocorrect="off"
                autocomplete="off"
                :type="types"
                :inputmode="inputmode"
                :maxlength="( isTW || (Object.keys(this.countryCodeData).length > 0 && defaultCountryCodeData.code==='+886')) ? 10 : maxlength">
        <slot/>

        <el-button type="text" class="open-eyes" @click="openEyes" v-if="(IsFocus||Model!=='') && this.$public.isCordova()">
            <i class="el-icon-view"/>
        </el-button>

    </div>

</template>

<script>
import CountryCodeSelect from "@/components/CountryCodeSelect";
export default {
    name: "OpenEyes",
    props:{
        value:{default: ''},
        name:{default: ''},
        type:{},
        maxlength:{default: 15},
        placeholder:{default: ''},
        disabled:{default: false},
        isLogin:Boolean,
        isCountryCode: Boolean, //是否有國碼
        isTW: Boolean, //是否固定TW +886國碼
        countryCodeData: {default: () => ({})},
    },
    components:{
        CountryCodeSelect,
    },
    data() {
        return {
            Eyes: false,
            Model: Object.keys(this.countryCodeData).length > 0 ? this.countryCodeData.tel : this.value,
            IsFocus: false,
            cType: this.type,
            types: '',
            inputmode: '',
            defaultCountryCodeData: {cnName: "台灣", code: "+886", countryEnNameCode: "TW+886", enName: "TW", key: 1}, //國碼物件與Calculator模組回傳一致
            selectCountryCodeData: this.countryCodeData !== undefined ? this.countryCodeData : this.defaultCountryCodeData,
        }
    },
    mounted() {
        if(this.type==='chinese'){
            //需有中文輸入的鍵盤，用css去控制隱藏文字
            this.types='text'
        }else {
            //L3檢測只有針對APP，網頁版部分預設都開啟操作才流暢
            if(this.$public.isCordova()) {
                this.types = 'password'
            }
            //輸入為數字鍵盤
            if (this.type === 'tel') {
                this.inputmode = 'numeric'
            }
        }
        if(!this.$public.isCordova()) {
            this.Eyes = true
        }
    },
    watch: {
        Model(v) {
            this.$emit('visible-change', this.defaultCountryCodeData, v )
            this.$emit('onChange', Object.keys(this.countryCodeData).length > 0 ? this.defaultCountryCodeData : this.name, v )
        },
        value() {
            this.Model = this.value;
        },
    },
    methods: {
        handleVisibleChange(payload) {
            // 國碼選擇雙向綁定
            this.defaultCountryCodeData = payload.countryCodeData;
            this.$emit('visible-change', payload.countryCodeData, this.Model )
            this.$emit('onChange', payload.countryCodeData, this.Model )
        },
        //L3檢測需求機密資料隱藏+眼睛開關
        openEyes(){
            this.Eyes=!this.Eyes
            if(this.type!=='chinese'){
                if (this.Eyes){
                    //信箱不要給提示字，type要下url
                    if(this.type==='url'){
                        this.types= 'url'
                    }else {
                        this.types= 'text'
                    }
                }else {
                    this.types="password"
                }
            }
            //如果focus時，按眼睛時，要維持focus不縮鍵盤
            if(this.placeholder!=='' && !this.disabled){
                const inputElement = this.$refs.eyes
                inputElement.focus()
                //光標移到最後面，如沒設時間會無效
                setTimeout(() => {
                    inputElement.selectionStart = inputElement.selectionEnd = inputElement.value.length;
                }, 10)
                this.IsFocus = true
            }
        },
        onFocus(){
            this.IsFocus = true
        },
        onBlur(){
            this.IsFocus = false
            //信箱不要給提示字，type要下url
            if(this.type==='url'){
                this.types="password"
                this.Eyes = false
            }
        },
        onChange(){
            if (this.name === "name") {
                this.$emit('setUserData', 'name', this.Model);
            }
            if (this.name === "formdate") {
                this.$emit('setUserData', 'formdate', this.Model);
            }
            if (this.name === "tel" || this.name === "loginTel" || this.name === "registeredFormTel") {
                this.$emit('onChange', this.defaultCountryCodeData, this.Model);
            }
        }
    }
}
</script>
<style scoped lang="less">
    .d-flex{
        align-items: center;
    }
    //L3檢測敏感性資料要遮蔽
    .show-password{
        -webkit-text-security:disc;
    }
    .open-eyes{
        width: 40px;
        padding: 0;
        height: 30px;
    }
    //固定台灣國碼
    .CountryCodeTW{
        flex: 0 0 90px;
        padding-left: 15px;
        color: #606266;
    }
</style>
